import {
  all,
  takeLatest,
  put,
  race,
  take,
} from 'redux-saga/effects';
import {
  BOOT_APP,
  CLIENT_REQUEST_FAILURE,
  CLIENT_REQUEST_SUCCESS,
  CARRIER_REQUEST_SUCCESS,
  THEME_REQUEST,
} from '../actionTypes';
import { getCarrier } from '../carrier';
import { getClient } from '../client';
import { signInDetails } from '../user';
import { setBootCompleteSuccess } from '../bootComplete';

function* bootApp(action) {
  yield put(getClient());
  yield put(signInDetails());
  yield put(getCarrier(action.carrierId));

  /* Wait for all the Redux updates corresponding to the requests above
   * This should trigger after the Redux update is applied, since it is async
   * and dispatch is synchronous
   */
  yield all([
    race([take(CLIENT_REQUEST_SUCCESS), take(CLIENT_REQUEST_FAILURE)]),
    take(CARRIER_REQUEST_SUCCESS),
    take(THEME_REQUEST),
  ]);
  yield put(setBootCompleteSuccess());
}

export default function* bootSaga() {
  yield takeLatest(BOOT_APP, bootApp);
}
